import { render, staticRenderFns } from "./NavbarLink.vue?vue&type=template&id=56f1d1aa&"
import script from "./NavbarLink.vue?vue&type=script&lang=js&"
export * from "./NavbarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports